// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1_YZe","cls2":"AuthorHeader-cls2_WLM AuthorHeader-cls1_YZe"};